export const timeData = [
  { id: "time", label: "Now", value: "{{time.now}}" },
  { id: "time", label: "Today", value: "{{time.today}}" },
  { id: "time", label: "Yesterday", value: "{{time.yesterday}}" },
  { id: "time", label: "Tomorrow", value: "{{time.tomorrow}}" },
  { id: "time", label: "This Week", value: "{{time.week}}" },
  { id: "time", label: "Last Week", value: "{{time.lastWeek}}" },
  { id: "time", label: "Next Week", value: "{{time.nextWeek}}" },
  { id: "time", label: "This Month", value: "{{time.month}}" },
  { id: "time", label: "Last Month", value: "{{time.lastMonth}}" },
  { id: "time", label: "Next Month", value: "{{time.nextMonth}}" },
  { id: "time", label: "This Year", value: "{{time.year}}" },
  { id: "time", label: "Last Year", value: "{{time.lastYear}}" },
  { id: "time", label: "Next Year", value: "{{time.nextYear}}" },
  { id: "time", label: "This Quarter", value: "{{time.quarter}}" },
  { id: "time", label: "Last Quarter", value: "{{time.lastQuarter}}" },
  { id: "time", label: "Next Quarter", value: "{{time.nextQuarter}}" },
];

export const variableData = [
  {
    id: "record",
    label: "Current Record (Record ID)",
    value: "{{record.id}}",
    type: "Record Reference",
  },
  {
    id: "record",
    label: "Current Record (Record Name)",
    value: "{{record._RecordName}}",
    type: "Record Reference",
  },
  {
    id: "user",
    label: "The User (Reference)",
    value: "{{user.id}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Full Name",
    value: "{{user._RecordName}}",
    type: "GrowthCloud User's Data",
  },

  {
    id: "user",
    label: "User's Email",
    value: "{{user.Email}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Phone",
    value: "{{user.Phone}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Mobile",
    value: "{{user.Mobile}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Title",
    value: "{{user.Title}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Company",
    value: "{{user.Company}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Reports To",
    value: "{{user.ReportsTo}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's First Name",
    value: "{{user.FirstName}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Middle Name",
    value: "{{user.MiddleName}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Last Name",
    value: "{{user.LastName}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Preferred Name",
    value: "{{user.PreferredName}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Pronouns",
    value: "{{user.Pronouns}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "user",
    label: "User's Description",
    value: "{{user.Description}}",
    type: "GrowthCloud User's Data",
  },
  {
    id: "workspace",
    label: "Administrators",
    value: "{{workspace.Administrators}}",
    type: "Workspace Members",
  },
  {
    id: "workspace",
    label: "Architects",
    value: "{{workspace.Architects}}",
    type: "Workspace Members",
  },
  {
    id: "workspace",
    label: "Contributors",
    value: "{{workspace.Contributors}}",
    type: "Workspace Members",
  },
  {
    id: "workspace",
    label: "Viewers",
    value: "{{workspace.Viewers}}",
    type: "Workspace Members",
  },
];
